/* Národní drip – ALT text is the ONLY source of gallery colour membership.
   Convention: "Popis fotografie | Barva: Název varianty".
   Media without a colour marker are shared across all variants.
   Supports new products without code changes. */
(() => {
  if (window.__ndAltGalleryLoaded) return;
  window.__ndAltGalleryLoaded = true;
  const normalize = value => String(value ?? '').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase('cs-CZ').replace(/\s+/g, ' ');
  const altColor = alt => {
    const found=String(alt ?? '').match(/(?:^|\|)\s*(?:barva|color|colour)\s*:\s*([^|\r\n]+)/i);
    return found ? normalize(found[1]) : null;
  };
  const config=()=>{
    const tag=document.querySelector('product-info script[data-nd-alt-color-gallery]');
    if(!tag) return null;
    try { return {...JSON.parse(tag.textContent), root:tag.closest('product-info')}; }
    catch { return null }
  };
  let selectedColor=null, applying=false, scheduled=false;
  function apply(){
    if(applying) return;
    const cfg=config();
    if(!cfg || !cfg.root) return;
    const allowed=new Set((cfg.colors || []).map(normalize));
    const current=normalize(selectedColor || cfg.initial);
    if(!current || !allowed.has(current)) return;
    const tags=new Map();
    for(const item of (cfg.media || [])){
      const c=altColor(item.alt);
      if(c && allowed.has(c)) tags.set(String(item.id),c);
    }
    // Fail open during partial setups: don't accidentally hide images when labels are incomplete.
    if(new Set(tags.values()).size < 2) return;
    const gallery=cfg.root.querySelector('media-gallery');
    const viewer=gallery?.querySelector('[id^="GalleryViewer-"]');
    if(!viewer) return;
    const slides=[...viewer.querySelectorAll('li[data-media-id]')];
    if(!slides.length) return;
    const visible=new Map();
    for(const slide of slides){
      const mId=String(slide.dataset.mediaId||'').split('-').pop();
      const belongs=tags.get(mId);
      visible.set(slide.dataset.mediaId,!belongs || belongs===current);
    }
    if(![...visible.values()].some(Boolean)) return;
    const show=(el,yes)=>{
      if(!el) return;
      if(yes) {el.style.removeProperty('display');el.removeAttribute('aria-hidden')}
      else {el.style.setProperty('display','none','important');el.setAttribute('aria-hidden','true')}
    };
    applying=true;
    try {
      for(const slide of slides) show(slide,visible.get(slide.dataset.mediaId));
      for(const thumb of gallery.querySelectorAll('li[data-target]')){
        show(thumb,visible.get(thumb.dataset.target)!==false);
      }
      const active=slides.find(s=>s.classList.contains('is-active'));
      const first=slides.find(s=>visible.get(s.dataset.mediaId));
      if(first && (!active || !visible.get(active.dataset.mediaId))){
        slides.forEach(s=>s.classList.toggle('is-active',s===first));
        for(const button of gallery.querySelectorAll('li[data-target] button')) button.removeAttribute('aria-current');
        gallery.querySelector('li[data-target="'+first.dataset.mediaId+'"] button')?.setAttribute('aria-current','true');
      }
      for(const component of [viewer,gallery.querySelector('[id^="GalleryThumbnails-"]')]){
        if(!component?.resetPages) continue;
        if(component.slider) component.slider.scrollLeft=0;
        component.resetPages();
        if(component.sliderItemsToShow?.length === 1){
          component.currentPage=1;
          component.totalPages=1;
          if(component.currentPageElement) component.currentPageElement.textContent='1';
          if(component.pageTotalElement) component.pageTotalElement.textContent='1';
          component.prevButton?.setAttribute('disabled','disabled');
          component.nextButton?.setAttribute('disabled','disabled');
        }
      }
    }finally{applying=false}
  }
  const schedule=()=>{
    if(scheduled) return;
    scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;apply()});
  };
  const start=()=>{
    const cfg=config();
    if(!cfg) return;
    selectedColor=cfg.initial;
    schedule();
    const slider=cfg.root?.querySelector('media-gallery [id^="Slider-Gallery-"]');
    if(slider){
      const observer=new MutationObserver(changes=>{
        if(changes.some(c=>c.type==='childList')) schedule();
      });
      observer.observe(slider,{childList:true});
    }
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined'){
      subscribe(PUB_SUB_EVENTS.variantChange,event=>{
        const v=event?.data?.variant;
        if(!v) return;
        const next=v.options?.[cfg.index] || v['option'+(Number(cfg.index)+1)];
        if(next)selectedColor=next;
        schedule();
      });
    }
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
